import React from 'react';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Reviews from './pages/Reviews';
import Courses from './pages/Courses';
import Tournament from './pages/Tournament';
import LegalPages from './pages/LegalPages';
import Contact from './pages/Contact';
import Basics from './pages/courses/Basics';
import Advanced from './pages/courses/Advanced';
import Tournamentcourses from './pages/courses/Tournament';
// import HallOfFame from './pages/HallOfFame';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './animations.min.css';

// ScrollToTop component to reset scroll on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50 overflow-x-hidden">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/tournament" element={<Tournament />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/courses/basics" element={<Basics />} />
          <Route path="/courses/advanced" element={<Advanced />} />
          <Route path="/courses/tournament" element={<Tournamentcourses />} />
          {/* <Route path="/hall-of-fame" element={<HallOfFame />} /> */}
          <Route path="/:page" element={<LegalPages />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;